import {create, read, remove, update} from "@/api/rest";

const profilePage = {
  companies: async () => await read('/profile-page/companies'),
  saveCompany: async (data) => await create('/profile-page/save-company', data),
  updateCompany: async (data) => await update('/profile-page/update-company', data),
  deleteCompany: async(url) => await remove(url),
};

export default profilePage;